import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchProducts } from "../services/products.service";

export const fetchProducts = createAsyncThunk(
    "products/fetchProducts",
    async ({ page = 1, limit = 40, q = "", filters = {} }, { rejectWithValue }) => {
        try {
            const data = await getSearchProducts({ page, limit, q, filters });
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch products"
            );
        }
    }
);

const productSlice = createSlice({
    name: "products",
    initialState: {
        data: [],
        filters: {},
        sorting: {},
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.products;
                state.pagination = {
                    total: action.payload.total,
                    current_page: action.payload.current_page,
                    limit: action.payload.limit,
                };
                state.filters = action.payload.filters || {};
                state.sorting = action.payload.sorting.sort_by || {};
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});
export default productSlice.reducer;